import axios from "../axios";
import { useState, useEffect } from "react";
import urls from "../Utils/urls";
import { useAbortController } from "./useAbortController";

const useBorrowerProfile = (accountId) => {
  const [profile, setProfile] = useState({
    general: {},
    ach: {},
  });
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [generalInfo, achInfo] = await Promise.all([
          axios.get(urls.dashboard.getLoanTerm2(accountId), { signal }),
          axios.get(urls.borrower.getPaymentsLoanAchInfo(accountId), {
            signal,
          }),
        ]);

        // Process the loan term response
        if (generalInfo.data[0] && generalInfo.data[0].length > 0) {
          const profileData = transformLoanData(
            generalInfo.data[0][0],
            achInfo.data[0][0]
          );
          setProfile(profileData);
        }
      } catch (error) {
        if (error.name === "CanceledError") {
          console.error("Fetch request canceled", error.message);
        } else {
          console.error("Error fetching data:", error);
        }
      }
    };

    fetchAllData();
  }, [accountId, signal]);

  return profile;
};

const transformLoanData = (generalInfo, achInfo) => {
  return {
    general: {
      FullName: generalInfo.borrower_name,
      FirstName: generalInfo.borrower_first_name,
      LastName: generalInfo.borrower_last_name,
      Street: generalInfo.borrower_address,
      City: generalInfo.borrower_city,
      State: generalInfo.borrower_state,
      ZipCode: generalInfo.borrower_zip_code,
      EmailAddress: generalInfo.borrower_email?.split(";")?.[0],
      PhoneHome: generalInfo.borrower_home_phone,
      PhoneCell: generalInfo.borrower_mobile_phone,
      PhoneWork: generalInfo.borrower_work_phone,
      TIN: `${
        generalInfo.last_4_tax_id?.length > 0
          ? "00000" + generalInfo.last_4_tax_id
          : generalInfo.last_4_tax_id
      }`,
      TINType: 0,
    },
    ach: {
      ACH_RoutingNumber: achInfo.ACH_RoutingNumber,
      ACH_AccountNumber: achInfo.ACH_AccountNumber,
      ACH_IndividualId: "",
      ACH_IndividualName: achInfo.ACH_IndividualName,
      ACH_AccountType: achInfo.ACH_AccountType,
      ACH_ServiceStatus: achInfo.ACH_ServiceStatus,
    },
  };
};

export default useBorrowerProfile;
